import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgArrowNarrowUpRight = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 18 18 6m0 0h-8m8 0v8"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgArrowNarrowUpRight)
export default ForwardRef
